/** 星闪音乐律动 SDK 矩阵类型（与 XINGSHAN_LAYOUT_DATA 键一致） */
export type XingshanMusicLayoutKey =
  | "87"
  | "68"
  | "63"
  | "deep80max"
  | "84"
  | "es87"
  | "x75v3"
  | "gamma75"
  | "dk75"
  | "dk75Pro"
  | "dk75E";

function readConfigurationFromAppHidGlobalStore(): Record<
  string,
  unknown
> | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem("app-hidGlobalStore");
    if (!raw) return null;
    const parsed = JSON.parse(raw) as {
      state?: { configurationNow?: unknown };
    };
    const cfg = parsed?.state?.configurationNow;
    return cfg && typeof cfg === "object"
      ? (cfg as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}

/**
 * 按律动 target / 设备配置解析星闪音乐矩阵型号。
 * 禁止在全局律动下发路径依赖 app-hidGlobalStore 作为唯一来源。
 */
export function resolveXingshanMusicLayoutType(
  equipment?: Record<string, unknown> | null
): XingshanMusicLayoutKey {
  const cfg = equipment ?? readConfigurationFromAppHidGlobalStore();
  if (!cfg || String(cfg.solutionRovider ?? "") !== "xingshan") {
    return "87";
  }

  const productId = Number(cfg.productId);
  const vendorId = Number(cfg.vendorId);
  const keyboardType = String(cfg.keyboardType ?? "")
    .trim()
    .toLowerCase();

  if (productId === 7230 && vendorId === 7334) return "es87";
  if (productId === 7178 && vendorId === 7334) return "87";
  if (productId === 7180 && vendorId === 7334) return "deep80max";
  if (
    (productId === 7186 && vendorId === 7334) ||
    (productId === 7211 && vendorId === 7334) ||
    (productId === 7203 && vendorId === 7334) ||
    (productId === 7212 && vendorId === 7334) ||
    (productId === 7204 && vendorId === 7334) ||
    (productId === 65153 && vendorId === 6790) ||
    (productId === 7199 && vendorId === 7334) ||
    (productId === 7215 && vendorId === 7334) ||
    (productId === 7242 && vendorId === 7334) ||
    (productId === 7244 && vendorId === 7334) ||
    (productId === 7248 && vendorId === 7334)
  ) {
    return "68";
  }
  if (
    (productId === 24065 || productId === 7245 || productId === 7241) &&
    vendorId === 7334
  ) {
    return "63";
  }
  if ((productId === 7213 || productId === 7239) && vendorId === 7334) {
    return "x75v3";
  }
  /** EXXGamma75 / METAWAY Y75（0x1c37） */
  if (productId === 7223 && vendorId === 7334) return "gamma75";
  /** DK75 Pro / ZE75（0x2709） */
  if (productId === 0x2709 && vendorId === 7334) return "dk75Pro";
  /** DK75 E（0x2708） */
  if (productId === 0x2708 && vendorId === 7334) return "dk75E";
  /** DK75 标准款（0x270a，F 行 PrtScr + 旋钮） */
  if (productId === 0x270a && vendorId === 7334) return "dk75";
  /** EXXGamma75 Ultra 双灯位（0x1c45） */
  if (productId === 0x1c45 && vendorId === 7334) return "gamma75";
  /** EXXGamma75 Pro（0x1c4e） / Pro Evo（0x1c51） */
  if ((productId === 0x1c4e || productId === 0x1c51) && vendorId === 7334) {
    return "gamma75";
  }

  if (keyboardType === "gamma75") return "gamma75";
  if (keyboardType === "x75v3") return "x75v3";
  if (keyboardType === "dk75e" || keyboardType === "dk75E") return "dk75E";
  if (keyboardType === "dk75pro" || keyboardType === "dk75Pro") {
    return "dk75Pro";
  }
  if (keyboardType === "dk75") return "dk75";

  if (
    keyboardType === "68" ||
    keyboardType === "68evo" ||
    keyboardType === "deep68"
  ) {
    return "68";
  }
  if (keyboardType === "63") return "63";
  if (keyboardType === "es87") return "es87";
  if (keyboardType === "87") return "87";
  if (keyboardType === "84") return "84";
  if (keyboardType === "deep80max") return "deep80max";

  const blob =
    `${cfg.displayname ?? ""} ${cfg.productName ?? ""}`.toUpperCase();
  if (/\bES87\b/.test(blob)) return "es87";
  if (/\bES68\b|\bDK68\b|\bDEEP68\b/.test(blob)) return "68";
  if (/\bES63\b|\bDK63\b|DK63V2/.test(blob)) return "63";
  if (/\bGAMMA75\b|\bEXXGAMMA75\b|\bMETAWAY\s*Y75\b/i.test(blob)) {
    return "gamma75";
  }
  if (/\bDK75\s*E\b/i.test(blob)) return "dk75E";
  if (/\bDK75\s*PRO\b/i.test(blob) || /\bZE75\b/i.test(blob)) return "dk75Pro";
  if (/\bDK75\b/i.test(blob)) return "dk75";
  if (/\bX75\s*V3\b/i.test(blob)) return "x75v3";

  return "87";
}
